@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.formWrapper {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  position: relative;
  padding-top: 3px;
  .formCard {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .infoWrapper {
      margin-top:  hevo-toolkit-variables.$spacer * 0.65;
      margin-bottom:  hevo-toolkit-variables.$spacer * 1.25;
    }

    .fixedWrapper {
      z-index: 10;
      position: sticky;
      bottom: 0px;
      padding-bottom:  hevo-toolkit-variables.$spacer * 1.25;
      padding-top:  hevo-toolkit-variables.$spacer * 2;
      background: linear-gradient(
        to top,
         hevo-toolkit-variables.$surface-bg,
         hevo-toolkit-variables.$surface-bg 52%,
         hevo-toolkit-variables.$surface-bg-0
      );
    }
  }

  &.backdrop::after {
    content: ' ';
    background:  hevo-toolkit-variables.$surface-bg-60;
    position: absolute;
    height: 100%;
    width: 100%;
    padding:  hevo-toolkit-variables.$spacer * 0.65 0px;
    top: 0;
    left: 0;
    z-index: 4;
  }

  .hideOverlay {
    z-index: 5;
  }
}
